import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import { LicenseInfo } from "@mui/x-license";
import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";

import "inter-ui/inter.css";
import { FormContextProvider } from "./contexts/form";
import { LanguageContextProvider } from "./contexts/language";
import { MapContextProvider } from "./contexts/map";
import { Router } from "./router";
import theme from "./theme";

import "./i18n";

console.log(`--- APP VERSION : ${__APP_VERSION__}`);

///////////////////////////////
// React Query              ///
///////////////////////////////

const queryClient: QueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            // staleTime: 120000,
        },
    },
});

///////////////////////////////
// Sentry                   ///
///////////////////////////////

if (import.meta.env.VITE_SENTRY_ENVIRONMENT === "production") {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_AUTH_TOKEN,
        integrations: [new Sentry.BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}

/////////////////////////////////
//  MUI PRO LICENSE     ///
// //////////////////////////////////
LicenseInfo.setLicenseKey(VITE_DATA_GRID_LICENSE_KEY);

///////////////////////////////
// Render                   ///
///////////////////////////////

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <LanguageContextProvider>
                <MapContextProvider>
                    <FormContextProvider>
                        <ThemeProvider theme={theme}>
                            <CssBaseline enableColorScheme />
                            <GlobalStyles
                                styles={{
                                    ":root": {
                                        "--primary-main":
                                            theme.palette.primary.main,
                                        "--secondary-main":
                                            theme.palette.secondary.main,
                                        "--common-white":
                                            theme.palette.common.white,
                                    },
                                }}
                            />
                            <Router />
                        </ThemeProvider>
                    </FormContextProvider>
                </MapContextProvider>
            </LanguageContextProvider>
        </QueryClientProvider>
    </React.StrictMode>,
);
